'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.filters = twentyninetimes.filters || function () {

	function init() {

		var filterContainer = document.getElementById('js-filters');

		if ( filterContainer ) filterList(filterContainer);

	}

	function filterList(filterContainer) {
	    var filtersScrollContainer = filterContainer.querySelector('.filters__inner'),
	    	filterResetBtns = document.querySelectorAll('.js-filter-reset'),
	        resultsArray = [];
	    let filters = filterContainer.querySelectorAll('.js-filter-dropdown'),
	    	filterResultsBtn = filterContainer.querySelector('.js-filter-results-btn');
	    if ( filters ) {
			
			window.addEventListener("click", (e) => {

				var target = e.target;
				if ( target.closest('.js-filter-dropdown') ) return;

				filters.forEach((filter) => {
					filter.classList.remove('open');
				});
			});

	        filters.forEach((filter) => {

	            var trigger = filter.querySelector('.js-filter-toggle'),
	                content = filter.querySelector('.js-filter-content');

	            trigger.addEventListener('click', (e) => {
	                e.stopPropagation();

	                var currentOpen = filterContainer.querySelector('.js-filter-dropdown.open');
	                if ( currentOpen && filter != currentOpen ) currentOpen.classList.remove('open');

	                ( filter.classList.contains('open') )
	                    ? filter.classList.remove('open')
	                    : filter.classList.add('open');
	            });
	        });

	        filterResultsBtn.addEventListener('click', (e) => {
	        	
	        	// the new url string
	        	var new_url = setFilterParams().toString() + '#js-filters';

	        	window.location.href = new_url;
	        });
	    }

	    var filterInputs = filterContainer.querySelectorAll('.js-filter-dropdown input');
	    if ( filterInputs ) {
	        filterInputs.forEach((input) => {
	            input.addEventListener('input', (e) => {
	                e.stopPropagation();

	                var target 		= e.target,
	                	taxonomy 	= target.getAttribute('name'),
	                	value 		= target.value;

	                var checkedInputs = document.querySelectorAll('.js-filter-dropdown input:checked');
	                
	                ( checkedInputs.length ) 
	                    ? filterContainer.classList.add('show-results-btn')
	                    : filterContainer.classList.remove('show-results-btn');
	            });
	        });
	    }

	    if ( filterResetBtns ) {
	    	filterResetBtns.forEach((resetBtn) => {
		        resetBtn.addEventListener('click', (e) => {
		            e.stopPropagation();

		            resetFilters();
		        });
	    	});
	    }

	    function resetFilters() {
	    	filterInputs.forEach((input) => {
	    	    input.checked = false;
	    	});

	    	filters.forEach((filter) => {
	    	    filter.classList.remove('open');
	    	});

	    	var url = window.location.href.split(/[?#]/)[0] + '#js-filters';
	    	window.location.href = url;
	    }

	    function setFilterParams() {
	    	if ( filters ) {
	    		var url = new URL(window.location.href.split(/[?#]/)[0]),
	    			params = url.searchParams;

	    	    filters.forEach((filter) => {
	    	    	var taxonomy = filter.getAttribute('data-filter-slug'),
	    	    		checkedInputs = filter.querySelectorAll('input:checked');

    	    		if ( !checkedInputs.length ) return;

    	    		var inputString = '';

	    			checkedInputs.forEach((input) => {
	    				inputString += inputString == ''
	    					? input.value
	    					: '-'+input.value;
	    			});

	    			if ( inputString != '' ) params.set(taxonomy, inputString);
	    	    }); 

	    	    var tab_partner = document.querySelector('.js-tab-toggle.tab-item--partner.active');
	    	    if ( tab_partner ) {
	    	    	var partner_tax_id = tab_partner.querySelector('input').getAttribute('data-tax-id');
	    	    	params.append('tax_partner_type', partner_tax_id);
	    	    }

	    	    return url;
	    	}
	    }

	    var filterMobileToggle = document.querySelector('.js-filter-mobile-toggle');
	    if ( filterMobileToggle ) {
			filterMobileToggle.addEventListener('click', (e) => {
	    		e.stopPropagation();

	    		if ( !filterContainer.classList.contains('open') ) {
	    			filterContainer.classList.add('open');

	    			document.body.classList.add('no-scroll');
	    			bodyScrollLock.disableBodyScroll(filtersScrollContainer);
	    		} else {
	    			filterContainer.classList.add('open');

	    			document.body.classList.remove('no-scroll');
	    			bodyScrollLock.enableBodyScroll(filtersScrollContainer);
	    		}
	    	});
	    }
	}

	return {
		init : init
	};

}();